<template>
  <vx-card style="min-height: 400px">
    <div class="vx-row">
      <div class="vx-col lg:w-1/3 w-full flex items-center">
        <span class="w-1/3">{{cat?"Kategori Seçiniz":"Kategori Giriniz"}}</span>
        <vs-switch class="w-1/12 mr-2" v-model="cat" />
        <v-select
          v-if="cat"
          class="w-full"
          placeholder="Kategori Seçiniz"
          :options="vehicleDropDowns.categories"
          label="value"
          v-model="selectedCategory"
        />
        <vs-input v-if="!cat" class="w-full" placeholder="Kategori Giriniz" v-model="categoryName" />
      </div>

      <div class="vx-col lg:w-1/3 w-full flex items-center">
        <span class="w-1/3">{{brand?"Marka Seçiniz":"Marka Giriniz"}}</span>
        <vs-switch :disabled="!cat" class="w-1/12 mr-2" v-model="brand" />
        <v-select
          v-if="brand"
          class="w-full"
          placeholder="Marka Seçiniz"
          :options="vehicleDropDowns.brands"
          label="value"
          v-model="selectedBrand"
        >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
        <vs-input v-if="!brand" class="w-full" placeholder="Marka Giriniz" v-model="brandName" />
      </div>

      <div class="vx-col lg:w-1/3 w-full flex items-center">
        <span class="w-4/12">{{model?"Model Seçiniz":"Model Giriniz"}}</span>
        <vs-switch :disabled="!cat" class="w-1/12 mr-2" v-model="model" />
        <v-select
          v-if="model"
          class="w-full"
          maxHeight="200px"
          placeholder="Model Seçiniz"
          :disabled="!carSelection() || !cat"
          :options="modelFinder()"
          label="value"
          v-model="selectedModel"
        >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
        <vs-input v-if="!model" class="w-full" placeholder="Model Giriniz" v-model="modelName" />
      </div>
    </div>
    <div class="flex flex-wrap items-center justify-end mt-10">
      <vs-button class="ml-auto mt-2" @click="submit()">Kaydet</vs-button>
      <vs-button class="ml-4 mt-2" type="border" @click="cancel()" color="warning">Vazgeç</vs-button>
    </div>
  </vx-card>
</template>


<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

export default {
  components: {
    vSelect
  },
  data() {
    return {
      cat: true,
      brand: true,
      model: false,
      selectedCategory: "",
      selectedBrand: "",
      selectedModel: "",
      categoryName: "",
      brandName: "",
      modelName: "",
      vehicleDropDowns: [],
      postmodel: []
    };
  },
  watch: {
    cat: function() {
      if (this.cat == false) {
        this.brand = false;
        this.model = false;
      }
    }
  },
  methods: {
    setter() {
      if (this.cat == true) {
        this.postmodel.push({
          category: this.selectedCategory
        });
      } else if (this.cat == false) {
        this.postmodel.push({
          category: this.categoryName
        });
      }
      if (this.brand == true) {
        this.postmodel.push({
          brand: this.selectedBrand
        });
      } else if (this.brand == false) {
        this.postmodel.push({
          brand: this.brandName
        });
      }
      if (this.model == true) {
        this.postmodel.push({
          model: this.selectedModel
        });
      } else if (this.model == false) {
        this.postmodel.push({
          model: this.modelName
        });
      }
    },
    submit() {
      this.postmodel = [];
      this.setter();
    },
    cancel() {
      this.postmodel = [];
      this.selectedCategory = "";
      this.selectedBrand = "";
      this.selectedModel = "";
      this.categoryName = "";
      this.brandName = "";
      this.modelName = "";
    },
    //araçların çekilmesi
    getVehicleDropDown: async function() {
      let x = await repository
        .getAll("Technic/getVehicleDropDowns")
        .then(r => r.entity);
      this.vehicleDropDowns = x;
    },
    //garaj girişinde araçların kategori ve marka seçimine göre model seçilimi
    carSelection() {
      if (this.selectedCategory != "" && this.selectedBrand != "") {
        return true;
      } else return false;
    },
    //garaj girişinde araçların kategori ve marka seçimine göre modellerin listelenemsi
    modelFinder() {
      if (this.carSelection())
        return this.vehicleDropDowns.models.filter(
          x =>
            x.brandId == this.selectedBrand.id &&
            x.categoryId == this.selectedCategory.id
        );
    }
  },
  created() {
    this.getVehicleDropDown();
  }
};
</script>
